export default {
  ru: 'Русский',
  en: 'English',
  de: "Deutsch"
}